export default {
  computed: {
    isAuth(){
      return this.$store.state.isAuth
    }
  }
}
